import { InjectionToken } from '@angular/core';
import { ReviewsDependencies } from './interface';
import { SourceSelectionDependencies } from './source-selection/types';

export const ReviewsInjectionToken = new InjectionToken<ReviewsDependencies>('dependencies for displaying reviews');
export const SourceSelectionInjectionToken = new InjectionToken<SourceSelectionDependencies>(
  'dependencies for selecting sources',
);
